import React from 'react';
import ReactDOM from 'react-dom'
import {connect} from 'react-redux'
import {hydrate} from 'react-dom'
import PropTypes from 'prop-types';

import config from "common/config";
import ExternalService from './external-service';

import Loading from '../../loading/loading'

import './external.styl'
class External extends React.Component {
    static propTypes = {
        url: PropTypes.string,
        config: PropTypes.instanceOf(config).isRequired,
    }

    static contextTypes = {
        store: PropTypes.object.isRequired
    }

    state = {
        html: false,
        loaded: false
    }

    externalService = new ExternalService(this.props.config)

    UNSAFE_componentWillMount() {
        this.state.locale = this.context.store.app.locale
    }

    componentDidMount () {
        this.get(this.state.locale)
    }

    componentDidUpdate() {
        if(!this.state.html) return
        this.refs.iframe.contentDocument.body.innerHTML = this.state.html
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.locale !== this.state.locale) this.get(nextProps.locale)
    }

    get(locale) {
        this.setState({loaded: false, html: false})
        this.externalService.content(this.props.url, {locale}).then(html => this.setState({locale, html}))
    }

    onload(data) {
        if(this.state.loaded) return
        const nodeIframe = this.refs.iframe
        const nodeExternal = this.refs.external;
        const node = nodeIframe.contentWindow.document.body
        nodeIframe.style.height = node.offsetHeight + 'px';
        nodeIframe.style.width = node.offsetWidth + 'px';
        nodeExternal.style.height = node.offsetHeight + 'px';
        nodeExternal.style.width = node.offsetWidth + 'px';
        this.setState({loaded: true})

        nodeIframe.src = this.props.url + '?locale=' + this.state.locale
    }

    render() {
        const {html, loaded} = this.state

        return <div className="external" ref="external">
            <Loading printable={!loaded} ref="loading" />
            {html && <iframe ref="iframe" onLoad={this.onload.bind(this)} />}
        </div>
    }
}

export default connect(state => ({locale: state.langReducers.locale}))(External)
